import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import AlertModal from './common/AlertModal';

const GoogleLoginButton = ({ id = 'googleSignInButton' }) => {
  const { login } = useAuth();
  const [alertModal, setAlertModal] = useState({ show: false, title: '', message: '', type: 'error' });

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
          ux_mode: 'popup',
          auto_select: false,
        });
        
        window.google.accounts.id.renderButton(
          document.getElementById(id),
          { theme: 'filled_black', size: 'large', text: 'signin_with' }
        );
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleCredentialResponse = async (response) => {
    const result = await login(response.credential);
    if (!result.success) {
      setAlertModal({
        show: true,
        title: 'Login Failed',
        message: result.error || 'Unable to sign in. Please try again.',
        type: 'error'
      });
    }
  };

  return (
    <div>
      <div id={id} data-testid="google-login-button"></div>
      {!process.env.REACT_APP_GOOGLE_CLIENT_ID && (
        <div className="text-yellow-500 text-sm mt-2">
          Google Client ID not configured
        </div>
      )}

      <AlertModal
        show={alertModal.show}
        title={alertModal.title}
        message={alertModal.message}
        type={alertModal.type}
        onClose={() => setAlertModal({ show: false, title: '', message: '', type: 'error' })}
      />
    </div>
  );
};

export default GoogleLoginButton;